import { HttpErrorResponse } from '@angular/common/http';
import { Action } from '@ngrx/store';
import { UserActivationPayload } from '@shared/models/activation.models';
import { ChallengeQuestionPayload } from '@shared/models/challenge-question-payload';
import { ChangePasswordRequest } from '@shared/models/change-password-request';
import { SecurityQuestions } from '@shared/models/security-questions';
import { SetNewPasswordPayload } from '@shared/models/set-new-password-payload';
import { ValidationApiError } from '@shared/models/validation-api-error';

export const RESET_PASSWORD = '[User] Reset Password';
export const RESET_PASSWORD_SUCCESS = '[User] Reset Password Success';
export const RESET_PASSWORD_FAIL = '[User] Reset Password Fail';

export class ResetPassword implements Action {
  readonly type = RESET_PASSWORD;
  constructor(public payload: { email: string; recaptcha: string }) {}
}

export class ResetPasswordSuccess implements Action {
  readonly type = RESET_PASSWORD_SUCCESS;
}

export class ResetPasswordFailure implements Action {
  readonly type = RESET_PASSWORD_FAIL;
  constructor(public payload: HttpErrorResponse) {}
}

export const CHANGE_PASSWORD = '[User] Change Password';
export const CHANGE_PASSWORD_SUCCESS = '[User] Change Password Success';
export const CHANGE_PASSWORD_FAIL = '[User] Change Password Fail';
export const CHANGE_PASSWORD_REFRESH = '[User] Change Password Refresh';

export class ChangePassword implements Action {
  readonly type = CHANGE_PASSWORD;
  constructor(public payload: ChangePasswordRequest) {}
}

export class ChangePasswordSuccess implements Action {
  readonly type = CHANGE_PASSWORD_SUCCESS;
}

export class ChangePasswordFail implements Action {
  readonly type = CHANGE_PASSWORD_FAIL;
  constructor(public payload: HttpErrorResponse) {}
}

export class ChangePasswordRefresh implements Action {
  readonly type = CHANGE_PASSWORD_REFRESH;
}

export const SET_NEW_PASSWORD = '[User] Set New Password';
export const SET_NEW_PASSWORD_SUCCESS = '[User] Set New Password Success';
export const SET_NEW_PASSWORD_FAIL = '[User] Set New Password Fail';

export class SetNewPassword implements Action {
  readonly type = SET_NEW_PASSWORD;
  constructor(public payload: SetNewPasswordPayload) {}
}

export class SetNewPasswordSuccess implements Action {
  readonly type = SET_NEW_PASSWORD_SUCCESS;
}

export class SetNewPasswordFail implements Action {
  readonly type = SET_NEW_PASSWORD_FAIL;
  constructor(public payload: HttpErrorResponse) {}
}

export const GET_SECURITY_QUESTIONS = '[User] Get Security Questions';
export const GET_SECURITY_QUESTIONS_SUCCESS = '[User] Get Security Questions Success';
export const GET_SECURITY_QUESTIONS_FAIL = '[User] Get Security Questions Fail';

export class GetSecurityQuestions implements Action {
  readonly type = GET_SECURITY_QUESTIONS;
}

export class GetSecurityQuestionsSuccess implements Action {
  readonly type = GET_SECURITY_QUESTIONS_SUCCESS;
  constructor(public payload: SecurityQuestions) {}
}

export class GetSecurityQuestionsFail implements Action {
  readonly type = GET_SECURITY_QUESTIONS_FAIL;
  constructor(public payload: ValidationApiError[]) {}
}

export const GET_CHALLENGE_QUESTION = '[User] Get Challenge Question';
export const GET_CHALLENGE_QUESTION_SUCCESS = '[User] Get Challenge Question Success';
export const GET_CHALLENGE_QUESTION_FAIL = '[User] Get Challenge Question Fail';

export class GetChallengeQuestion implements Action {
  readonly type = GET_CHALLENGE_QUESTION;
  constructor(public payload: ChallengeQuestionPayload) {}
}

export class GetChallengeQuestionSuccess implements Action {
  readonly type = GET_CHALLENGE_QUESTION_SUCCESS;
  constructor(public payload: string) {}
}

export class GetChallengeQuestionFail implements Action {
  readonly type = GET_CHALLENGE_QUESTION_FAIL;
  constructor(public payload: ValidationApiError[]) {}
}

export const ACTIVATE_USER = '[User] Activate User';
export const ACTIVATE_USER_SUCCESS = '[User] Activate User Success';
export const ACTIVATE_USER_FAIL = '[User] Activate User Fail';

export class ActivateUser implements Action {
  readonly type = ACTIVATE_USER;
  constructor(public payload: UserActivationPayload) {}
}

export class ActivateUserSuccess implements Action {
  readonly type = ACTIVATE_USER_SUCCESS;
}

export class ActivateUserFail implements Action {
  readonly type = ACTIVATE_USER_FAIL;
  constructor(public payload: ValidationApiError[]) {}
}

export type UserPasswordAction =
  | ResetPassword
  | ResetPasswordSuccess
  | ResetPasswordFailure
  | ChangePassword
  | ChangePasswordSuccess
  | ChangePasswordFail
  | ChangePasswordRefresh
  | SetNewPassword
  | SetNewPasswordSuccess
  | SetNewPasswordFail
  | GetSecurityQuestions
  | GetSecurityQuestionsSuccess
  | GetSecurityQuestionsFail
  | GetChallengeQuestion
  | GetChallengeQuestionSuccess
  | GetChallengeQuestionFail
  | ActivateUser
  | ActivateUserSuccess
  | ActivateUserFail;
